export const findParentFolder = (folders, path) => {
  if (!path) {
    return folders
  }

  const subs = path.split('/')
  subs.forEach((sub) => {
    folders = folders.children.find(({ name }) => name === sub)
  })

  return folders
}

export const findFolderById = (folders, id) => {
  if (!id || id === -1) {
    return folders
  }

  if (folders.id === id) {
    return folders
  }

  if (folders.children && folders.children.length > 0) {
    for (const child of folders.children) {
      const found = findFolderById(child, id)
      if (found) {
        return found
      }
    }
  }

  return find(folders, id)
}
